import { Suspense, memo } from 'react';
import { Switch, Route } from 'react-router-dom';
import PrivateRoute from 'components/common/PrivateRoute';
// Import UI components
import { BusyLoader } from '@geneui/components';

import { publicRoutesList, notFoundRoute } from './config';

const PublicRoutes = () => {
    return (
        <Suspense
            fallback={
                <BusyLoader
                    isBusy={true}
                    type="spinner"
                    spinnerSize="big"
                    className="crm-full-width crm-justify-content-center"
                />
            }
        >
            <Switch>
                {publicRoutesList.map(({ isPrivate, path, exact, component, titleKey }, index) => {
                    if (isPrivate) {
                        return <PrivateRoute path={path} component={component} key={index} titleKey={titleKey} />;
                    } else {
                        const Component = component;

                        return (
                            <Route path={path} exact={exact} key={index}>
                                <Component titleKey={titleKey} />
                            </Route>
                        );
                    }
                })}

                <Route component={notFoundRoute.component} />
            </Switch>
        </Suspense>
    );
};

export default memo(PublicRoutes);
